var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 269.704,
    height: 264.041,
    viewBox: "0 0 269.704 264.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(-147.998 -261.183)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    transform: "translate(154.701 313.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    transform: "translate(163.701 297.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 35.371,
    cy: 35.371,
    r: 35.371,
    transform: "translate(244.741 314.479)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M861.652,671.055a131.8,131.8,0,0,1-19.2,11.07l-.99-1.75-9.48-16.64-.83-1.46-4.85-8.51-.01-.01-15.31-26.9-7.87-13.81,23.37-16.39,9.09,19.22,4.93,10.44,20.29,42.91Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M840.772,606.155l-2.93-4.59-12.96-20.33a16.356,16.356,0,1,0-29.9,13.27l8.01,28.54a5.875,5.875,0,0,0,7.99,3.81c.03-.01.05-.02.08-.03l24.51-10.95,2.64-1.18a5.9,5.9,0,0,0,2.56-8.54Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M770.352,606.795l-6.82,15.4-1.48,3.35-25.25,57.04-.81,1.83a131.1,131.1,0,0,1-19.68-10.24l.68-1.92L737.6,614.1l5.06-14.28,11.08,2.79Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M840.192,613.245a66.808,66.808,0,0,0-2.35-11.68,65.094,65.094,0,0,0-18.809-29.84,17.788,17.788,0,0,0-11.9-4.55h-42.29a17.783,17.783,0,0,0-15.93,25.78l4.83,9.66,9.79,19.58,2.35,4.69,10.47,20.95.83,1.66,53.15,14.62.23-.51c.2-.45.4-.89.59-1.33.29-.67.58-1.32.85-1.98,5.36-12.71,7.89-24.02,8.5-33.98a75.655,75.655,0,0,0-.31-13.07Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 30.019,
    cy: 30.019,
    r: 30.019,
    transform: "translate(240.493 370.24) rotate(-61.337)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M772.512,572.655a16.332,16.332,0,0,0-21.69,7.8l-3.77,5.69-12.6,19.02a5.893,5.893,0,0,0,2.41,8.59l.74.35,24.45,11.44,1.74.81a5.66,5.66,0,0,0,2.09.53,5.763,5.763,0,0,0,2.82-.49,5.878,5.878,0,0,0,3.23-3.68l8.46-28.31A16.372,16.372,0,0,0,772.512,572.655Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M832,660.295a5.46,5.46,0,0,0-.85-1.73,22.88,22.88,0,0,0-4.85-4.8l-.01-.01c-6.43-4.87-19.23-10.56-43.92-10.71h-.04a5.9,5.9,0,0,0-5.37,3.45l-.61,1.34-3.93,8.64a4.507,4.507,0,0,1-1.53,1.85c-3.55,2.51-14.85,11.61-20.69,28.99-.21.62-.41,1.25-.6,1.9a132.1,132.1,0,0,0,76.37-.69l.55-2.27,5.46-22.52.09-.37a5.91,5.91,0,0,0-.07-3.07Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M756.322,508.745a40.829,40.829,0,0,0,23.333,7.211,25.02,25.02,0,0,1-9.917,4.08,82.329,82.329,0,0,0,33.628.189,21.764,21.764,0,0,0,7.04-2.418A8.909,8.909,0,0,0,814.752,512c.738-4.215-2.547-8.044-5.96-10.625a43.96,43.96,0,0,0-36.941-7.382c-4.127,1.067-8.26,2.869-10.941,6.183s-3.474,8.423-.921,11.836Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M657.722,579.345c-.1-.72-.18-1.45-.26-2.17-.02-.11-.03-.21-.04-.32q-.435-3.945-.63-7.97-.825,3.465-1.49,6.96c.03.34.06.67.1,1.01.01.11.02.21.04.32.08.72.16,1.45.26,2.17.28,2.23.62,4.43,1.02,6.62.01-.09.02-.17.03-.26.28-2.11.6-4.21.98-6.31a.091.091,0,0,1-.01-.05Zm141.1-148.27c-.72-.07-1.45-.13-2.17-.18-.11-.01-.21-.01-.32-.02-3.2-.24-6.44-.36-9.7-.36A132.041,132.041,0,0,0,655.3,575.845c.03.34.06.67.1,1.01.01.11.02.21.04.32.08.72.16,1.45.26,2.17.28,2.23.62,4.43,1.02,6.62a132.574,132.574,0,0,0,79.27,98.45c2.08.86,4.18,1.68,6.31,2.43,1.4.51,2.8.98,4.22,1.43,1.02.33,2.05.64,3.08.94,1.46.43,2.94.84,4.43,1.22a131.355,131.355,0,0,0,107.62-19.38h.01a131.929,131.929,0,0,0,56.97-108.54c0-68.68-52.72-125.27-119.81-131.44Zm61.97,238.15a129.376,129.376,0,0,1-19.33,11.15,128.01,128.01,0,0,1-14.94,5.88,130.229,130.229,0,0,1-71.08,2.47q-2.64-.645-5.24-1.41-2.565-.75-5.08-1.59c-1.37-.47-2.74-.95-4.1-1.46-1.42-.54-2.82-1.1-4.22-1.68a130.335,130.335,0,0,1-79.07-103.19.093.093,0,0,1-.01-.05c-.1-.72-.18-1.45-.26-2.17-.02-.11-.03-.21-.04-.32q-.435-3.945-.63-7.97-.165-3.165-.16-6.37a130.142,130.142,0,0,1,130-130c3.26,0,6.5.12,9.7.36l.32.03c.72.05,1.45.11,2.17.18,65.99,6.16,117.81,61.85,117.81,129.43a129.9,129.9,0,0,1-55.815,106.693Zm-119.77,15.04c-1.42-.54-2.82-1.1-4.22-1.68a130.335,130.335,0,0,1-79.07-103.19c-.38,2.1-.7,4.2-.98,6.31-.01.09-.02.17-.03.26a132.574,132.574,0,0,0,79.27,98.45c2.08.86,4.18,1.68,6.31,2.43C741.862,685.995,741.432,685.135,741.022,684.265Zm55.31-253.39c-3.2-.24-6.44-.36-9.7-.36A132.041,132.041,0,0,0,655.3,575.845c.03.34.06.67.1,1.01.01.11.02.21.04.32h2.02c-.02-.11-.03-.21-.04-.32q-.435-3.945-.63-7.97-.165-3.165-.16-6.37a130.142,130.142,0,0,1,130-130c3.26,0,6.5.12,9.7.36l.32.03v-2.01c-.11-.01-.21-.01-.32-.02Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M893.927,464.3c40.544.692,40.538,61,0,61.687C853.383,525.3,853.389,464.988,893.927,464.3Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#ce5947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M893.927,511.94a2.17,2.17,0,0,1-2.168-2.168V498.279a.967.967,0,0,0-.966-.966H879.3a2.168,2.168,0,1,1,0-4.336h11.493a.967.967,0,0,0,.966-.966V480.518a2.168,2.168,0,1,1,4.336,0v11.494a.967.967,0,0,0,.966.966h11.493a2.168,2.168,0,1,1,0,4.336H897.06a.967.967,0,0,0-.966.966v11.493a2.17,2.17,0,0,1-2.167,2.167Z",
    transform: "translate(-506.631 -169.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 14.636,
    cy: 10.977,
    rx: 14.636,
    ry: 10.977,
    transform: "translate(226.634 325.604) rotate(-45)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 10.977,
    cy: 14.636,
    rx: 10.977,
    ry: 14.636,
    transform: "translate(285.749 318.147) rotate(-66.869)",
    fill: "#2f2e41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.cbc75c94239bcebae18568eeb874207e.svg";
export { ForwardRef as ReactComponent };